<template>
  <div>
    <header>
      <nav class="sticky-nav">
        <router-link to="/" class="logo-link">
          <div class="logo-container">
            <div class="logo">
              <img src="./assets/air-surgical-logo.png" alt="Air Surgical">
            </div>
          </div>
        </router-link>
        <button type="button" class="nav-toggle" aria-label="Toggle menu" :aria-expanded="menuOpen" @click="menuOpen = !menuOpen">
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
        </button>
        <ul class="nav-links" :class="{ 'nav-links-open': menuOpen }">
          <li><router-link to="/" @click="menuOpen = false">Home</router-link></li>
          <li><router-link to="/technology" @click="menuOpen = false">Technology</router-link></li>
          <li><router-link to="/contact" @click="menuOpen = false">Contact</router-link></li>
          <li><router-link to="/about" @click="menuOpen = false">About</router-link></li>
        </ul>
      </nav>
    </header>
    <router-view></router-view>
    <footer>
      <p class="investigational">CAUTION—Investigational device. Limited by Federal (or United States) law to investigational use.</p>
      <p class="copyright">&copy; 2026 AIR Surgical, Inc. All rights reserved.</p>
      <p class="footer-links">
        <a href="#">Privacy</a><span class="sep"> · </span><a href="#">Terms</a>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return { menuOpen: false };
  },
  watch: {
    $route() {
      this.menuOpen = false;
    }
  }
}
</script>

<style scoped>
.sticky-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: white;
  padding: 10px 0px;
}

.logo-container {
  display: flex;
  align-items: center;
  margin: 0 10px;
}

.logo img {
  height: 50px;
  margin: 0px;
}

.blue-text {
  color: #66a3ff;
  font-weight: bold;
  font-size: 20px;
}

.bold-text {
  font-weight: bold;
  font-size: 20px;
  margin-left: -3px;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  position: relative;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  padding: 0;
  margin-right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 4px;
}
.nav-toggle:hover {
  background: #f1f5f9;
}
.nav-toggle-bar {
  display: block;
  width: 22px;
  height: 2px;
  background: #1a1a1a;
  border-radius: 1px;
  transition: transform 0.2s, opacity 0.2s;
}
.nav-toggle[aria-expanded="true"] .nav-toggle-bar:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.nav-toggle[aria-expanded="true"] .nav-toggle-bar:nth-child(2) {
  opacity: 0;
}
.nav-toggle[aria-expanded="true"] .nav-toggle-bar:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.nav-links {
  list-style-type: none;
  padding: 0 15px;
  margin: 0;
}

li {
  display: inline;
  margin-left: 20px;
}

a {
  color: #000;
  text-decoration: none;
}

nav a:hover {
  color: #2563eb;
}

footer {
  background-color: white;
  color: #1e1e1e;
  padding: 20px 0;
  text-align: center;
}

footer p {
  font-size: 14px;
  font-weight: normal;
  margin: 0 0 0.5rem 0;
}

footer .investigational {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 1rem;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

footer p:last-child {
  margin-bottom: 0;
}

.footer-links {
  font-size: 13px;
  opacity: 0.85;
}

.footer-links a {
  color: inherit;
}

.footer-links a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .nav-toggle {
    display: flex;
  }

  .nav-links {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    padding: 16px 0;
    display: flex;
    flex-direction: column;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.2s;
  }

  .nav-links-open {
    max-height: 320px;
    opacity: 1;
  }

  .nav-links li {
    display: block;
    margin: 0;
    border-bottom: 1px solid #f1f5f9;
  }
  .nav-links li:last-child {
    border-bottom: none;
  }

  .nav-links a {
    display: block;
    padding: 14px 24px;
    font-size: 16px;
  }
}

@media (max-width: 600px) {
  .sticky-nav {
    padding: 6px 0;
  }

  .logo img {
    height: 35px;
  }
}
</style>
